import React from "react";
import ReactLoading from "react-loading";
export const Loading = () => {
  return (
    <div align="center">
      <ReactLoading type="bubbles" color="black" height={"50%"} width={"10%"} />
      ;
    </div>
  );
};
